import { SvgIconProps } from './icon-props';

export default function LocationPin({
	fill = 'none',
	height = 16,
	role,
	width = 15,
}: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 15 16"
			fill={fill}
			xmlns="http://www.w3.org/2000/svg"
			role={role}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.0629 6.18964C9.0629 5.3144 8.3633 4.60528 7.50009 4.60528C6.63688 4.60528 5.93728 5.3144 5.93728 6.18964C5.93728 7.06428 6.63722 7.774 7.50009 7.774C8.36296 7.774 9.0629 7.06428 9.0629 6.18964ZM9.50875 6.18966C9.50875 7.31392 8.60921 8.22602 7.50008 8.22602C6.39095 8.22602 5.49142 7.31392 5.49142 6.18966C5.49142 5.06476 6.39065 4.15329 7.50008 4.15329C8.60951 4.15329 9.50875 5.06476 9.50875 6.18966ZM8.01889 13.2799C8.53957 12.5727 9.06023 11.8267 9.54586 11.0765C9.88337 10.5551 10.1919 10.0498 10.4651 9.56715C11.2832 8.12128 11.7416 6.9527 11.7416 6.18965C11.7416 3.8146 9.84269 1.88951 7.49995 1.88951C5.15721 1.88951 3.2583 3.8146 3.2583 6.18965C3.2583 6.9527 3.71666 8.12128 4.53483 9.56715C4.80797 10.0498 5.11653 10.5551 5.45404 11.0765C5.93967 11.8267 6.46033 12.5727 6.98101 13.2799C7.16324 13.5274 7.33241 13.7523 7.48415 13.9503C7.66749 13.7523 7.83666 13.5274 8.01889 13.2799ZM12.1875 6.18964C12.1875 7.05575 11.7069 8.28098 10.8519 9.79206C10.574 10.2831 10.2608 10.796 9.91866 11.3245C9.42766 12.083 8.90194 12.8363 8.37624 13.5503C8.19223 13.8002 8.02133 14.0274 7.86788 14.2276C7.77561 14.348 7.70951 14.4329 7.67395 14.4778C7.58471 14.5907 7.41529 14.5907 7.32605 14.4778C7.29049 14.4329 7.22439 14.348 7.13212 14.2276C6.97867 14.0274 6.80777 13.8002 6.62376 13.5503C6.09806 12.8363 5.57234 12.083 5.08134 11.3245C4.73919 10.796 4.42601 10.2831 4.14814 9.79206C3.29307 8.28098 2.8125 7.05575 2.8125 6.18964C2.8125 3.56496 4.91102 1.4375 7.5 1.4375C10.089 1.4375 12.1875 3.56496 12.1875 6.18964Z"
				fill="#1F1F1F"
			/>
		</svg>
	);
}
